import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";
import { useCenter } from "../../context/CenterContext";
import { useSubject } from "../../context/SubjectContext";
import { useDashboard } from "../../context/DashboardContext";
import { QUALIFICATION_NAME, UI_MESSAGES } from "../../constants/Constants";
import { getQualificationTitle } from "../../utils/utils";

const LandingPage = () => {
  const { subjects, subjectData } = useSubject();
  const { centerName, centerNumber } = useCenter();
  const { fetchDashboardDetails, loadingDashboard } = useDashboard();
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();

  const handleTileClick = async (subject, index) => {
    setActiveIndex(subject.subjectId);
   
    await fetchDashboardDetails(subject, centerNumber);
    // Navigate after short delay (or immediately)
    setTimeout(() => {
      navigate("/dashboard");
    }, 300);
  };

  return (
    <div className="landing-page container is-fluid">
      <div className="content">
        <h1 className="title is-3">Cambridge OCR Moderation Service</h1>
        <h3 className="subtitle is-5">
          {centerNumber} - {centerName}
        </h3>
        <p className="pt-4">
          This service allows you to <strong>submit moderation visit requests</strong> and{" "}
          <strong>submit marks</strong> for your candidates. <br />
          If you need help, please contact{" "}
          <a href="mailto:support@ocr.org.uk">support@ocr.org.uk</a>.
        </p>
      </div>

      <div className="columns mb-0 mt- -2 mr-4">
        <div className="column is-12">
          <h2 className="title is-4">Select a subject</h2>
          <hr />
          <div className="columns">
            <div className="column is-5">
              <h3 className="title is-6">{getQualificationTitle(subjects, subjectData?.selectedSubjectId)}</h3>
              {Array.isArray(subjects) && subjects.length > 0 ? (
                [...subjects]
                  .filter(subject => subject.qualificationShortName === QUALIFICATION_NAME.AAQS_SUBJECT_NAME)
                  .sort((a, b) => a.subjectName.localeCompare(b.subjectName))
                  .map((subject, index) => (
                    <button
                      key={subject.subjectId}
                      disabled={loadingDashboard}
                      className={`subject-tile active box is-flex is-justify-content-space-between is-align-items-center ${
                        activeIndex === subject.subjectId ? "selected" : ""
                      }`}
                      onClick={() => handleTileClick(subject, index)}
                    >
                      <span style={{ fontSize: "16px", textAlign: "left" }}>
                        {subject.subjectName}
                      </span>
                      <span className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 -960 960 960"
                          width="24px"
                          fill="#0076BD"
                        >
                          <path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z" />
                        </svg>
                      </span>
                    </button>
                  ))
              ) : (
                <div>{UI_MESSAGES.NO_DATA_FOUND}</div>
              )}
            </div>

            <div className="column is-2" />

            <div className="column is-5">
              <h3 className="title is-6">Enrichment qualifications</h3>
              {Array.isArray(subjects) &&
              subjects.filter(s => QUALIFICATION_NAME.ENRICHMENT_SUBJECT_NAMES.includes(s.qualificationShortName)).length > 0 ? (
                [...subjects]
                  .filter(subject => QUALIFICATION_NAME.ENRICHMENT_SUBJECT_NAMES.includes(subject.qualificationShortName))
                  .sort((a, b) => a.subjectName.localeCompare(b.subjectName))
                  .map((subject, index) => (
                    <button
                      key={subject.subjectId}
                      disabled={loadingDashboard}
                      className={`subject-tile box is-flex is-justify-content-space-between is-align-items-center ${
                        activeIndex === subject.subjectId ? "selected" : ""
                      }`}
                      onClick={() => handleTileClick(subject, index)}
                    >
                      <span>{subject.subjectName}</span>
                      <span className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 -960 960 960"
                          width="24px"
                          fill="#0076BD"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z" />
                        </svg>
                      </span>
                    </button>
                  ))
              ) : (
                <div>{UI_MESSAGES.NO_DATA_FOUND}</div>
              )}

              <hr />

              <div className="card p-4">
                <h3 className="title is-6">Physical Education</h3>
                <p className="mb-4">
                  Please go to our PE Moderation Service to submit moderation
                  visit requests and submit activity marks.
                </p>
                <button
                  className="button is-link is-outlined"
                  onClick={() =>
                    window.open(
                      process.env.REACT_APP_MY_CAMBRIDGE_PE,
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  PE Moderation Service <span className="icon ml-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#0076BD"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z" />
                    </svg>
                  </span>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;